// extracted by mini-css-extract-plugin
module.exports = {"item":"FollowerItemList_item__2mT4W","sending":"FollowerItemList_sending__2ZWag"};